module.exports = __webpack_public_path__ + "static/media/VI.12125e72.png";